import * as angular from 'angular';
import CreationHubPageBridge from './components/CreationHubPageBridge';
import { CreateProcessMapHubPageBridge } from './components/CreateProcessMapHubPageBridge';
import { CreateWorkflowHubPageBridge } from './components/CreateWorkflowHubPageBridge';
import { FlowModelFromXPageBridge } from './components/FlowModelFromXPageBridge';
import { CreateProcedureHubPageBridge } from './components/CreateProcedureHubPageBridge';
import { ProcedureFromXPageBridge } from './components/ProcedureFromXPageBridge';

angular
  .module('flowingly.runner.creation-hub')
  .component('creationHubPage', CreationHubPageBridge)
  .component('createProcessMapHubPage', CreateProcessMapHubPageBridge)
  .component('createWorkflowHubPage', CreateWorkflowHubPageBridge)
  .component('flowModelFromXPage', FlowModelFromXPageBridge)
  .component('createProcedureHubPage', CreateProcedureHubPageBridge)
  .component('procedureFromXPage', ProcedureFromXPageBridge);
